import Box from '@eversports/klimt-primitives/legacy/Box'
import Collapse from '@eversports/klimt-primitives/legacy/Collapse'
import FormattedContent from '@eversports/klimt-primitives/legacy/FormattedContent'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import ChevronDownIcon from '../../assets/icons/chevron-down.svg'
import { useCancellationConditionsMatchQuery } from '../../graphql'
import { Localized } from '../../localization/react'

import { VALID_BALLSPORT_MATCH_STATES } from './Match.constants'

const CancellationsConditions = () => {
  const { id } = useParams<{ id: string }>()
  const { data } = useCancellationConditionsMatchQuery({ variables: { matchId: id } })
  const [isCollapsed, setIsCollapsed] = useState(false)

  if (!data?.match?.cancellationCondition) {
    return null
  }

  const isValidState = VALID_BALLSPORT_MATCH_STATES.includes(data.match.state)

  if (!isValidState) return null

  const cancellationConditions = data.match.cancellationCondition

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  return (
    <Stack gap={1} py={[1, 0]} px={2}>
      <Stack
        gap={2}
        direction="row"
        alignItems="center"
        width="fit-content"
        sx={{ cursor: 'pointer' }}
        onClick={toggleCollapse}
      >
        <Text color="midnight" style={{ textDecoration: 'underline' }}>
          <Localized id="cancellation-conditions-header-for-organizers" />
        </Text>
        <Box sx={{ transform: isCollapsed ? 'rotate(180deg)' : 'initial' }}>
          <Icon src={ChevronDownIcon} size="x-small" color="darkgray" />
        </Box>
      </Stack>
      <Collapse in={isCollapsed}>
        <FormattedContent htmlContent={cancellationConditions} />
      </Collapse>
    </Stack>
  )
}

export default CancellationsConditions
